/**
 * * 全国省份省会经纬度数据
 * ! 人力逐个搬运，请妥善保管
 * by:zengxiangkai@ly-sky.com
 */
const geoCoordMap = {
    '北京市': [116.4, 39.9],
    '天津市': [117.2, 39.12],
    '河北省': [114.52, 38.05],
    '山西省': [112.55, 37.87],
    '内蒙古自治区': [111.73, 40.83],
    '辽宁省': [123.43, 41.8],
    '吉林省': [125.32, 43.9],
    '黑龙江省': [126.53, 45.8],
    '上海市': [121.47, 31.23],
    '江苏省': [118.78, 32.07],
    '浙江省': [120.15, 30.28],
    '安徽省': [117.25, 31.83],
    '福建省': [119.3, 26.08],
    '江西省': [115.85, 28.68],
    '山东省': [116.98, 36.67],
    '河南省': [113.62, 34.75],
    '湖北省': [114.3, 30.6],
    '湖南省': [112.93, 28.23],
    '广东省': [113.27, 23.13],
    '广西壮族自治区': [108.37, 22.82],
    '海南省': [110.32, 20.03],
    '重庆市': [106.55, 29.57],
    '四川省': [104.07, 30.67],
    '贵州省': [106.72, 26.57],
    '云南省': [102.72, 25.05],
    '西藏自治区': [91.13, 29.65],
    '陕西省': [108.93, 34.27],
    '甘肃省': [103.82, 36.07],
    '青海省': [101.78, 36.62],
    '宁夏回族自治区': [106.28, 38.47],
    '新疆维吾尔自治区': [87.62, 43.82],
    '台湾省': [121.5, 25.03],
    '香港特别行政区': [114.08, 22.2],
    '澳门特别行政区': [113.33, 22.13],
    '北京': [116.4, 39.9],
    '天津': [117.2, 39.12],
    '河北': [114.52, 38.05],
    '山西': [112.55, 37.87],
    '内蒙古': [111.73, 40.83],
    '辽宁': [123.43, 41.8],
    '吉林': [125.32, 43.9],
    '黑龙江': [126.53, 45.8],
    '上海': [121.47, 31.23],
    '江苏': [118.78, 32.07],
    '浙江': [120.15, 30.28],
    '安徽': [117.25, 31.83],
    '福建': [119.3, 26.08],
    '江西': [115.85, 28.68],
    '山东': [116.98, 36.67],
    '河南': [113.62, 34.75],
    '湖北': [114.3, 30.6],
    '湖南': [112.93, 28.23],
    '广东': [113.27, 23.13],
    '广西': [108.37, 22.82],
    '海南': [110.32, 20.03],
    '重庆': [106.55, 29.57],
    '四川': [104.07, 30.67],
    '贵州': [106.72, 26.57],
    '云南': [102.72, 25.05],
    '西藏': [91.13, 29.65],
    '陕西': [108.93, 34.27],
    '甘肃': [103.82, 36.07],
    '青海': [101.78, 36.62],
    '宁夏': [106.28, 38.47],
    '新疆': [87.62, 43.82],
    '台湾': [121.5, 25.03],
    '香港': [114.08, 22.2],
    '澳门': [113.33, 22.13],
    "东城区": [116.418757, 39.917544],
    "西城区": [116.366794, 39.915309],
    "朝阳区": [116.486409, 39.921489],
    "丰台区": [116.286968, 39.863642],
    "石景山区": [116.195445, 39.914601],
    "海淀区": [116.310316, 39.956074],
    "门头沟区": [116.105381, 39.937183],
    "房山区": [116.139157, 39.735535],
    "通州区": [116.658603, 39.902486],
    "顺义区": [116.653525, 40.128936],
    "昌平区": [116.235906, 40.218085],
    "大兴区": [116.338033, 39.728908],
    "怀柔区": [116.637122, 40.324272],
    "平谷区": [117.112335, 40.144783],
    "密云区": [116.843352, 40.377362],
    "延庆区": [115.985006, 40.465325],
    "和平区": [117.195907, 39.118327],
    "河东区": [117.226568, 39.122125],
    "河西区": [117.217536, 39.101897],
    "南开区": [117.164143, 39.120474],
    "河北区": [117.201569, 39.156632],
    "红桥区": [117.163301, 39.175066],
    "东丽区": [117.313967, 39.087764],
    "西青区": [117.012247, 39.139446],
    "津南区": [117.382549, 38.989577],
    "北辰区": [117.13482, 39.225555],
    "武清区": [117.057959, 39.376925],
    "宝坻区": [117.308094, 39.716965],
    "滨海新区": [117.654173, 39.032846],
    "宁河区": [117.82828, 39.328886],
    "静海区": [116.925304, 38.935671],
    "蓟州区": [117.407449, 40.045342],
    "石家庄市": [114.502461, 38.045474],
    "唐山市": [118.175393, 39.635113],
    "秦皇岛市": [119.586579, 39.942531],
    "邯郸市": [114.490686, 36.612273],
    "邢台市": [114.508851, 37.0682],
    "保定市": [115.482331, 38.867657],
    "张家口市": [114.884091, 40.811901],
    "承德市": [117.939152, 40.976204],
    "沧州市": [116.857461, 38.310582],
    "廊坊市": [116.704441, 39.523927],
    "衡水市": [115.665993, 37.735097],
    "太原市": [112.549248, 37.857014],
    "大同市": [113.295259, 40.09031],
    "阳泉市": [113.583285, 37.861188],
    "长治市": [113.113556, 36.191112],
    "晋城市": [112.851274, 35.497553],
    "朔州市": [112.433387, 39.331261],
    "晋中市": [112.736465, 37.696495],
    "运城市": [111.003957, 35.022778],
    "忻州市": [112.733538, 38.41769],
    "临汾市": [111.517973, 36.08415],
    "吕梁市": [111.134335, 37.524366],
    "呼和浩特市": [111.670801, 40.818311],
    "包头市": [109.840405, 40.658168],
    "乌海市": [106.825563, 39.673734],
    "赤峰市": [118.956806, 42.275317],
    "通辽市": [122.263119, 43.617429],
    "鄂尔多斯市": [109.99029, 39.817179],
    "呼伦贝尔市": [119.758168, 49.215333],
    "巴彦淖尔市": [107.416959, 40.757402],
    "乌兰察布市": [113.114543, 41.034126],
    "兴安盟": [122.070317, 46.076268],
    "锡林郭勒盟": [116.090996, 43.944018],
    "阿拉善盟": [105.706422, 38.844814],
    "沈阳市": [123.429096, 41.796767],
    "大连市": [121.618622, 38.91459],
    "鞍山市": [122.995632, 41.110626],
    "抚顺市": [123.921109, 41.875956],
    "本溪市": [123.770519, 41.297909],
    "丹东市": [124.383044, 40.124296],
    "锦州市": [121.135742, 41.119269],
    "营口市": [122.235151, 40.667432],
    "阜新市": [121.648962, 42.011796],
    "辽阳市": [123.18152, 41.269402],
    "盘锦市": [122.06957, 41.124484],
    "铁岭市": [123.844279, 42.290585],
    "朝阳市": [120.451176, 41.576758],
    "葫芦岛市": [120.856394, 40.755572],
    "长春市": [125.3245, 43.886841],
    "吉林市": [126.55302, 43.843577],
    "四平市": [124.370785, 43.170344],
    "辽源市": [125.145349, 42.902692],
    "通化市": [125.936501, 41.721177],
    "白山市": [126.427839, 41.942505],
    "松原市": [124.823608, 45.118243],
    "白城市": [122.841114, 45.619026],
    "延边朝鲜族自治州": [129.513228, 42.904823],
    "哈尔滨市": [126.642464, 45.756967],
    "齐齐哈尔市": [123.95792, 47.342081],
    "鸡西市": [130.975966, 45.300046],
    "鹤岗市": [130.277487, 47.332085],
    "双鸭山市": [131.157304, 46.643442],
    "大庆市": [125.11272, 46.590734],
    "伊春市": [128.899396, 47.724775],
    "佳木斯市": [130.361634, 46.809606],
    "七台河市": [131.015584, 45.771266],
    "牡丹江市": [129.618602, 44.582962],
    "黑河市": [127.499023, 50.249585],
    "绥化市": [126.99293, 46.637393],
    "大兴安岭地区": [124.711526, 52.335262],
    "黄浦区": [121.490317, 31.222771],
    "徐汇区": [121.43752, 31.179973],
    "长宁区": [121.4222, 31.218123],
    "静安区": [121.448224, 31.229003],
    "普陀区": [121.392499, 31.241701],
    "虹口区": [121.491832, 31.26097],
    "杨浦区": [121.522797, 31.270755],
    "闵行区": [121.375972, 31.111658],
    "宝山区": [121.489934, 31.398896],
    "嘉定区": [121.250333, 31.383524],
    "浦东新区": [121.567706, 31.245944],
    "金山区": [121.330736, 30.724697],
    "松江区": [121.223543, 31.03047],
    "青浦区": [121.113021, 31.151209],
    "奉贤区": [121.458472, 30.912345],
    "崇明区": [121.397516, 31.626946],
    "南京市": [118.767413, 32.041544],
    "无锡市": [120.301663, 31.574729],
    "徐州市": [117.184811, 34.261792],
    "常州市": [119.946973, 31.772752],
    "苏州市": [120.619585, 31.299379],
    "南通市": [120.864608, 32.016212],
    "连云港市": [119.178821, 34.600018],
    "淮安市": [119.021265, 33.597506],
    "盐城市": [120.139998, 33.377631],
    "扬州市": [119.421003, 32.393159],
    "镇江市": [119.452753, 32.204402],
    "泰州市": [119.915176, 32.484882],
    "宿迁市": [118.275162, 33.963008],
    "杭州市": [120.153576, 30.287459],
    "宁波市": [121.549792, 29.868388],
    "温州市": [120.672111, 28.000575],
    "嘉兴市": [120.750865, 30.762653],
    "湖州市": [120.102398, 30.867198],
    "绍兴市": [120.582112, 29.997117],
    "金华市": [119.649506, 29.089524],
    "衢州市": [118.87263, 28.941708],
    "舟山市": [122.106863, 30.016028],
    "台州市": [121.428599, 28.661378],
    "丽水市": [119.921786, 28.451993],
    "合肥市": [117.283042, 31.86119],
    "芜湖市": [118.376451, 31.326319],
    "蚌埠市": [117.363228, 32.939667],
    "淮南市": [117.018329, 32.647574],
    "马鞍山市": [118.507906, 31.689362],
    "淮北市": [116.794664, 33.971707],
    "铜陵市": [117.816576, 30.929935],
    "安庆市": [117.043551, 30.50883],
    "黄山市": [118.317325, 29.709239],
    "滁州市": [118.316264, 32.303627],
    "阜阳市": [115.819729, 32.896969],
    "宿州市": [116.984084, 33.633891],
    "六安市": [116.507676, 31.752889],
    "亳州市": [115.782939, 33.869338],
    "池州市": [117.489157, 30.656037],
    "宣城市": [118.757995, 30.945667],
    "福州市": [119.306239, 26.075302],
    "厦门市": [118.11022, 24.490474],
    "莆田市": [119.007558, 25.431011],
    "三明市": [117.635001, 26.265444],
    "泉州市": [118.589421, 24.908853],
    "漳州市": [117.661801, 24.510897],
    "南平市": [118.178459, 26.635627],
    "龙岩市": [117.02978, 25.091603],
    "宁德市": [119.527082, 26.65924],
    "南昌市": [115.892151, 28.676493],
    "景德镇市": [117.214664, 29.29256],
    "萍乡市": [113.852186, 27.622946],
    "九江市": [115.992811, 29.712034],
    "新余市": [114.930835, 27.810834],
    "鹰潭市": [117.033838, 28.238638],
    "赣州市": [114.940278, 25.85097],
    "吉安市": [114.986373, 27.111699],
    "宜春市": [114.391136, 27.8043],
    "抚州市": [116.358351, 27.98385],
    "上饶市": [117.971185, 28.44442],
    "济南市": [117.000923, 36.675807],
    "青岛市": [120.355173, 36.082982],
    "淄博市": [118.047648, 36.814939],
    "枣庄市": [117.557964, 34.856424],
    "东营市": [118.66471, 37.434564],
    "烟台市": [121.391382, 37.539297],
    "潍坊市": [119.107078, 36.70925],
    "济宁市": [116.587245, 35.415393],
    "泰安市": [117.129063, 36.194968],
    "威海市": [122.116394, 37.509691],
    "日照市": [119.461208, 35.428588],
    "莱芜市": [117.677736, 36.214397],
    "临沂市": [118.326443, 35.065282],
    "德州市": [116.307428, 37.453968],
    "聊城市": [115.980367, 36.456013],
    "滨州市": [118.016974, 37.383542],
    "菏泽市": [115.469381, 35.246531],
    "郑州市": [113.665412, 34.757975],
    "开封市": [114.341447, 34.797049],
    "洛阳市": [112.434468, 34.663041],
    "平顶山市": [113.307718, 33.735241],
    "安阳市": [114.352482, 36.103442],
    "鹤壁市": [114.295444, 35.748236],
    "新乡市": [113.883991, 35.302616],
    "焦作市": [113.238266, 35.23904],
    "濮阳市": [115.041299, 35.768234],
    "许昌市": [113.826063, 34.022956],
    "漯河市": [114.026405, 33.575855],
    "三门峡市": [111.194099, 34.777338],
    "南阳市": [112.540918, 32.999082],
    "商丘市": [115.650497, 34.437054],
    "信阳市": [114.075031, 32.123274],
    "周口市": [114.649653, 33.620357],
    "驻马店市": [114.024736, 32.980169],
    "济源市": [112.590047, 35.090378],
    "武汉市": [114.298572, 30.584355],
    "黄石市": [115.077048, 30.220074],
    "十堰市": [110.787916, 32.646907],
    "宜昌市": [111.290843, 30.702636],
    "襄阳市": [112.144146, 32.042426],
    "鄂州市": [114.890593, 30.396536],
    "荆门市": [112.204251, 31.03542],
    "孝感市": [113.926655, 30.926423],
    "荆州市": [112.23813, 30.326857],
    "黄冈市": [114.879365, 30.447711],
    "咸宁市": [114.328963, 29.832798],
    "随州市": [113.37377, 31.717497],
    "恩施土家族苗族自治州": [109.48699, 30.283114],
    "仙桃市": [113.453974, 30.364953],
    "潜江市": [112.896866, 30.421215],
    "天门市": [113.165862, 30.653061],
    "神农架林区": [110.671525, 31.744449],
    "长沙市": [112.982279, 28.19409],
    "株洲市": [113.151737, 27.835806],
    "湘潭市": [112.944052, 27.82973],
    "衡阳市": [112.607693, 26.900358],
    "邵阳市": [111.46923, 27.237842],
    "岳阳市": [113.132855, 29.37029],
    "常德市": [111.691347, 29.040225],
    "张家界市": [110.479921, 29.127401],
    "益阳市": [112.355042, 28.570066],
    "郴州市": [113.032067, 25.793589],
    "永州市": [111.608019, 26.434516],
    "怀化市": [109.97824, 27.550082],
    "娄底市": [112.008497, 27.728136],
    "湘西土家族苗族自治州": [109.739735, 28.314296],
    "广州市": [113.280637, 23.125178],
    "韶关市": [113.591544, 24.801322],
    "深圳市": [114.085947, 22.547],
    "珠海市": [113.553986, 22.224979],
    "汕头市": [116.708463, 23.37102],
    "佛山市": [113.122717, 23.028762],
    "江门市": [113.094942, 22.590431],
    "湛江市": [110.364977, 21.274898],
    "茂名市": [110.919229, 21.659751],
    "肇庆市": [112.472529, 23.051546],
    "惠州市": [114.412599, 23.079404],
    "梅州市": [116.117582, 24.299112],
    "汕尾市": [115.364238, 22.774485],
    "河源市": [114.697802, 23.746266],
    "阳江市": [111.975107, 21.859222],
    "清远市": [113.051227, 23.685022],
    "东莞市": [113.746262, 23.046237],
    "中山市": [113.382391, 22.521113],
    "潮州市": [116.632301, 23.661701],
    "揭阳市": [116.355733, 23.543778],
    "云浮市": [112.044439, 22.929801],
    "南宁市": [108.320004, 22.82402],
    "柳州市": [109.411703, 24.314617],
    "桂林市": [110.299121, 25.274215],
    "梧州市": [111.297604, 23.474803],
    "北海市": [109.119254, 21.473343],
    "防城港市": [108.345478, 21.614631],
    "钦州市": [108.624175, 21.967127],
    "贵港市": [109.602146, 23.0936],
    "玉林市": [110.154393, 22.63136],
    "百色市": [106.616285, 23.897742],
    "贺州市": [111.552056, 24.414141],
    "河池市": [108.062105, 24.695899],
    "来宾市": [109.229772, 23.733766],
    "崇左市": [107.353926, 22.404108],
    "海口市": [110.33119, 20.031971],
    "三亚市": [109.508268, 18.247872],
    "三沙市": [112.34882, 16.831039],
    "儋州市": [109.576782, 19.517486],
    "五指山市": [109.516662, 18.776921],
    "琼海市": [110.466785, 19.246011],
    "文昌市": [110.753975, 19.612986],
    "万宁市": [110.388793, 18.796216],
    "东方市": [108.653789, 19.10198],
    "定安县": [110.349235, 19.684966],
    "屯昌县": [110.102773, 19.362916],
    "澄迈县": [110.007147, 19.737095],
    "临高县": [109.687697, 19.908293],
    "白沙黎族自治县": [109.452606, 19.224584],
    "昌江黎族自治县": [109.053351, 19.260968],
    "乐东黎族自治县": [109.175444, 18.74758],
    "陵水黎族自治县": [110.037218, 18.505006],
    "保亭黎族苗族自治县": [109.70245, 18.636371],
    "琼中黎族苗族自治县": [109.839996, 19.03557],
    "万州区": [108.380246, 30.807807],
    "涪陵区": [107.394905, 29.703652],
    "渝中区": [106.56288, 29.556742],
    "大渡口区": [106.48613, 29.481002],
    "江北区": [106.532844, 29.575352],
    "沙坪坝区": [106.4542, 29.541224],
    "九龙坡区": [106.480989, 29.523492],
    "南岸区": [106.560813, 29.523992],
    "北碚区": [106.437868, 29.82543],
    "綦江区": [106.651417, 29.028091],
    "大足区": [105.715319, 29.700498],
    "渝北区": [106.512851, 29.601451],
    "巴南区": [106.519423, 29.381919],
    "黔江区": [108.782577, 29.527548],
    "长寿区": [107.074854, 29.833671],
    "江津区": [106.253156, 29.283387],
    "合川区": [106.265554, 29.990993],
    "永川区": [105.894714, 29.348748],
    "南川区": [107.098153, 29.156646],
    "璧山区": [106.231126, 29.593581],
    "铜梁区": [106.054948, 29.839944],
    "潼南区": [105.841818, 30.189554],
    "荣昌区": [105.594061, 29.403627],
    "开州区": [108.413317, 31.167735],
    "梁平县": [107.800034, 30.672168],
    "城口县": [108.6649, 31.946293],
    "丰都县": [107.73248, 29.866424],
    "垫江县": [107.348692, 30.330012],
    "武隆县": [107.75655, 29.32376],
    "忠县": [108.037518, 30.291537],
    "云阳县": [108.697698, 30.930529],
    "奉节县": [109.465774, 31.019967],
    "巫山县": [109.878928, 31.074843],
    "巫溪县": [109.628912, 31.3966],
    "石柱土家族自治县": [108.112448, 29.99853],
    "秀山土家族苗族自治县": [108.996043, 28.444772],
    "酉阳土家族苗族自治县": [108.767201, 28.839828],
    "彭水苗族土家族自治县": [108.166551, 29.293856],
    "成都市": [104.065735, 30.659462],
    "自贡市": [104.773447, 29.352765],
    "攀枝花市": [101.716007, 26.580446],
    "泸州市": [105.443348, 28.889138],
    "德阳市": [104.398651, 31.127991],
    "绵阳市": [104.741722, 31.46402],
    "广元市": [105.829757, 32.433668],
    "遂宁市": [105.571331, 30.513311],
    "内江市": [105.066138, 29.58708],
    "乐山市": [103.761263, 29.582024],
    "南充市": [106.082974, 30.795281],
    "眉山市": [103.831788, 30.048318],
    "宜宾市": [104.630825, 28.760189],
    "广安市": [106.633369, 30.456398],
    "达州市": [107.502262, 31.209484],
    "雅安市": [103.001033, 29.987722],
    "巴中市": [106.753669, 31.858809],
    "资阳市": [104.641917, 30.122211],
    "阿坝藏族羌族自治州": [102.221374, 31.899792],
    "甘孜藏族自治州": [101.963815, 30.050663],
    "凉山彝族自治州": [102.258746, 27.886762],
    "贵阳市": [106.713478, 26.578343],
    "六盘水市": [104.846743, 26.584643],
    "遵义市": [106.937265, 27.706626],
    "安顺市": [105.932188, 26.245544],
    "毕节市": [105.28501, 27.301693],
    "铜仁市": [109.191555, 27.718346],
    "黔西南布依族苗族自治州": [104.897971, 25.08812],
    "黔东南苗族侗族自治州": [107.977488, 26.583352],
    "黔南布依族苗族自治州": [107.517156, 26.258219],
    "昆明市": [102.712251, 25.040609],
    "曲靖市": [103.797851, 25.501557],
    "玉溪市": [102.543907, 24.350461],
    "保山市": [99.167133, 25.111802],
    "昭通市": [103.717216, 27.336999],
    "丽江市": [100.233026, 26.872108],
    "普洱市": [100.972344, 22.777321],
    "临沧市": [100.08697, 23.886567],
    "楚雄彝族自治州": [101.546046, 25.041988],
    "红河哈尼族彝族自治州": [103.384182, 23.366775],
    "文山壮族苗族自治州": [104.24401, 23.36951],
    "西双版纳傣族自治州": [100.797941, 22.001724],
    "大理白族自治州": [100.225668, 25.589449],
    "德宏傣族景颇族自治州": [98.578363, 24.436694],
    "怒江傈僳族自治州": [98.854304, 25.850949],
    "迪庆藏族自治州": [99.706463, 27.826853],
    "拉萨市": [91.132212, 29.660361],
    "日喀则市": [88.885148, 29.267519],
    "昌都市": [97.178452, 31.136875],
    "山南市": [91.766529, 29.236023],
    "那曲地区": [92.060214, 31.476004],
    "阿里地区": [80.105498, 32.503187],
    "林芝市": [94.362348, 29.654693],
    "西安市": [108.948024, 34.263161],
    "铜川市": [108.979608, 34.916582],
    "宝鸡市": [107.14487, 34.369315],
    "咸阳市": [108.705117, 34.333439],
    "渭南市": [109.502882, 34.499381],
    "延安市": [109.49081, 36.596537],
    "汉中市": [107.028621, 33.077668],
    "榆林市": [109.741193, 38.290162],
    "安康市": [109.029273, 32.6903],
    "商洛市": [109.939776, 33.868319],
    "兰州市": [103.823557, 36.058039],
    "嘉峪关市": [98.277304, 39.786529],
    "金昌市": [102.187888, 38.514238],
    "白银市": [104.173606, 36.54568],
    "天水市": [105.724998, 34.578529],
    "武威市": [102.634697, 37.929996],
    "张掖市": [100.455472, 38.932897],
    "平凉市": [106.684691, 35.54279],
    "酒泉市": [98.510795, 39.744023],
    "庆阳市": [107.638372, 35.734218],
    "定西市": [104.626294, 35.579578],
    "陇南市": [104.929379, 33.388598],
    "临夏回族自治州": [103.212006, 35.599446],
    "甘南藏族自治州": [102.911008, 34.986354],
    "西宁市": [101.778916, 36.623178],
    "海东市": [102.10327, 36.502916],
    "海北藏族自治州": [100.901059, 36.959435],
    "黄南藏族自治州": [102.019988, 35.517744],
    "海南藏族自治州": [100.619542, 36.280353],
    "果洛藏族自治州": [100.242143, 34.4736],
    "玉树藏族自治州": [97.008522, 33.004049],
    "海西蒙古族藏族自治州": [97.370785, 37.374663],
    "银川市": [106.278179, 38.46637],
    "石嘴山市": [106.376173, 39.01333],
    "吴忠市": [106.199409, 37.986165],
    "固原市": [106.285241, 36.004561],
    "中卫市": [105.189568, 37.514951],
    "乌鲁木齐市": [87.617733, 43.792818],
    "克拉玛依市": [84.873946, 45.595886],
    "吐鲁番市": [89.184078, 42.947613],
    "哈密市": [93.51316, 42.833248],
    "昌吉回族自治州": [87.304012, 44.014577],
    "博尔塔拉蒙古自治州": [82.074778, 44.903258],
    "巴音郭楞蒙古自治州": [86.150969, 41.768552],
    "阿克苏地区": [80.265068, 41.170712],
    "克孜勒苏柯尔克孜自治州": [76.172825, 39.713431],
    "喀什地区": [75.989138, 39.467664],
    "和田地区": [79.92533, 37.110687],
    "伊犁哈萨克自治州": [81.317946, 43.92186],
    "塔城地区": [82.985732, 46.746301],
    "阿勒泰地区": [88.13963, 47.848393],
    "石河子市": [86.041075, 44.305886],
    "阿拉尔市": [81.285884, 40.541914],
    "图木舒克市": [79.077978, 39.867316],
    "五家渠市": [87.526884, 44.167401],
    "北屯市": [87.824932, 47.353177],
    "铁门关市": [85.501218, 41.827251],
    "双河市": [82.353656, 44.840524],
    "可克达拉市": [80.63579, 43.6832],
    "昆玉市": [79.287372, 37.207994],
    "台北": [121.509062, 25.044332],
    "中西区": [114.154334, 22.281931],
    "湾仔区": [114.18299, 22.276345],
    "东区": [114.225965, 22.279779],
    "南区": [114.160023, 22.245811],
    "油尖旺区": [114.173347, 22.311632],
    "深水埗区": [114.163349, 22.333775],
    "九龙城区": [114.193047, 22.312373],
    "黄大仙区": [114.203985, 22.336112],
    "观塘区": [114.214083, 22.320679],
    "荃湾区": [114.121234, 22.368458],
    "屯门区": [113.976308, 22.393896],
    "元朗区": [114.032528, 22.44132],
    "北区": [114.147404, 22.496143],
    "大埔区": [114.171713, 22.44573],
    "西贡区": [114.264813, 22.314203],
    "沙田区": [114.195126, 22.379715],
    "葵青区": [114.13918, 22.363908],
    "离岛区": [113.946059, 22.286371],
    "花地玛堂区": [113.552965, 22.207882],
    "花王堂区": [113.549052, 22.199175],
    "望德堂区": [113.550252, 22.193791],
    "大堂区": [113.55374, 22.188119],
    "风顺堂区": [113.54167, 22.187778],
    "嘉模堂区": [113.558783, 22.154124],
    "路凼填海区": [113.56925, 22.136546],
    "圣方济各堂区": [113.559954, 22.124049]
};

/**
 * * 全国、各省份地图大小样式数据
 * ! 人力逐个搬运，请妥善保管
 * by:zengxiangkai@ly-sky.com
 */
const mapStyleData = {
    '全国': { 'top': '10%', 'right': '5%', 'bottom': '5%', 'left': '5%' },
    '北京': { 'top': '10%', 'right': '15%', 'bottom': '5%', 'left': '15%' },
    '天津': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '30%' },
    '河北': { 'top': '10%', 'right': '20%', 'bottom': '5%', 'left': '20%' },
    '山西': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '35%' },
    '内蒙古': { 'top': '10%', 'right': '0%', 'bottom': '5%', 'left': '5%' },
    '辽宁': { 'top': '10%', 'right': '0%', 'bottom': '5%', 'left': '15%' },
    '吉林': { 'top': '10%', 'right': '0%', 'bottom': '5%', 'left': '10%' },
    '黑龙江': { 'top': '10%', 'right': '15%', 'bottom': '5%', 'left': '15%' },
    '上海': { 'top': '10%', 'right': '0%', 'bottom': '10%', 'left': '5%' },
    '江苏': { 'top': '10%', 'right': '5%', 'bottom': '5%', 'left': '20%' },
    '浙江': { 'top': '10%', 'right': '5%', 'bottom': '5%', 'left': '10%' },
    '安徽': { 'top': '10%', 'right': '25%', 'bottom': '5%', 'left': '25%' },
    '福建': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '10%' },
    '江西': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '30%' },
    '山东': { 'top': '15%', 'right': '0%', 'bottom': '15%', 'left': '5%' },
    '河南': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '10%' },
    '湖北': { 'top': '15%', 'right': '0%', 'bottom': '10%', 'left': '5%' },
    '湖南': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '25%' },
    '广东': { 'top': '10%', 'right': '0%', 'bottom': '10%', 'left': '5%' },
    '广西': { 'top': '10%', 'right': '0%', 'bottom': '5%', 'left': '5%' },
    '海南': { 'top': '10%', 'right': '25%', 'bottom': '5%', 'left': '30%' },
    '重庆': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '10%' },
    '四川': { 'top': '10%', 'right': '0%', 'bottom': '10%', 'left': '10%' },
    '贵州': { 'top': '10%', 'right': '0%', 'bottom': '5%', 'left': '5%' },
    '云南': { 'top': '10%', 'right': '5%', 'bottom': '5%', 'left': '10%' },
    '西藏': { 'top': '20%', 'right': '0%', 'bottom': '15%', 'left': '10%' },
    '陕西': { 'top': '10%', 'right': '15%', 'bottom': '5%', 'left': '35%' },
    '甘肃': { 'top': '10%', 'right': '5%', 'bottom': '5%', 'left': '5%' },
    '青海': { 'top': '10%', 'right': '0%', 'bottom': '10%', 'left': '10%' },
    '宁夏': { 'top': '10%', 'right': '10%', 'bottom': '5%', 'left': '25%' },
    '新疆': { 'top': '10%', 'right': '0%', 'bottom': '5%', 'left': '20%' },
    '台湾': { 'top': '10%', 'right': '0%', 'bottom': '10%', 'left': '10%' },
    '香港': { 'top': '10%', 'right': '5%', 'bottom': '5%', 'left': '10%' },
    '澳门': { 'top': '10%', 'right': '25%', 'bottom': '5%', 'left': '25%' },
}

export { geoCoordMap, mapStyleData };



// WEBPACK FOOTER //
// ./containers/Show-zzsd/data.js